import { isAfter, isSameDay, isValid, parse, startOfDay } from 'date-fns';

/** Full calendar date from InputDate / RHF (`toFormattedISODate`), distinct from slash display. */
const ISO_DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Use with `parse(..., format, ref)` when the string may be either slash/spaced display or `yyyy-MM-dd`
 * from `@alto/design-system` InputDate.
 */
export const resolveDobParseFormat = (value: string, format: string): string =>
  ISO_DATE_ONLY.test(value.trim()) ? 'yyyy-MM-dd' : format;

export const validateDateOfBirth = (value: string, format = 'MM/dd/yyyy') => {
  const regex = /\s/g;

  const parseFormat = resolveDobParseFormat(value, format);

  // only use trimmedValue if format doesn't have spaces
  const trimmedValue = parseFormat.match(regex) ? value : value.replace(regex, '');
  const dob = parse(trimmedValue, parseFormat, new Date());

  if (!isValid(dob)) {
    return `Must be valid date in format ${format}`;
  }

  const now = startOfDay(new Date());
  if (isSameDay(dob, now) || isAfter(dob, now)) {
    return 'Date must be in the past';
  }

  return undefined;
};
